import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from "rxjs";

import {AppAlertService} from "./app-alert.service";
import {ParametersService} from './parameters.service';
import {SubtitlesService} from "./subtitles.service";
import {UserService} from "./user.service";
import {ControlData, ControllerGroupData, TileOrderData} from "../models";

@Injectable({
    providedIn: 'root'
})
export class SendDataService {
    constructor(
        private http: HttpClient,
        private appAlert: AppAlertService,
        private parameters: ParametersService,
        private subtitles: SubtitlesService,
        private user: UserService,
    ) {
    }

    sendControlData(controlData: ControlData): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.showAppAlert(this.subtitles.setSubtitle(3529), this.subtitles.setSubtitle(475), null, false, null);
            return;
        }

        const baseUrl = `/api/v1/users/${this.user.user_id}/modules/${this.parameters.selectedModuleHash}`;
        const {menuType, ido, data} = controlData;
        const query = `/menu/${menuType}/ido/${ido}`;

        this.http.post(`${baseUrl}${query}`, data).subscribe();
    }

    addControllerGroup(data: string): Observable<ControllerGroupData> {
        const baseUrl = `/api/v1/users/${this.user.user_id}/modules/${this.parameters.selectedModuleHash}`;

        return this.http.post<ControllerGroupData>(`${baseUrl}/group`, data);
    };

    sendTilesOrder(data: TileOrderData, udid: string): Observable<unknown> {
        return this.http.post(`/api/v1/users/${this.user.user_id}/modules/${udid}/tiles/order`, data);
    };

    deleteModule(udid: string): Observable<unknown> {
        return this.http.delete(`/api/v1/users/${this.user.user_id}/modules/${udid}`);
    };
}
